import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCommentVisibility, type CommentDTO } from '../services/api/comments';

export interface UpdateCommentVisibilityVariables {
  taskId: number;
  commentId: number;
  isInternalOnly: boolean;
}

/**
 * MKS-185 — flip an existing comment between internal-only and public.
 *
 * Wait-for-server (D-16), like the sibling edit mutation: the visibility badge
 * must never show a state the server has not accepted. On success it only
 * invalidates ['comments', taskId] — a visibility flip notifies nobody and
 * subscribes nobody, so (unlike an edit) there is no watcher list to refresh.
 */
export function useUpdateCommentVisibility() {
  const queryClient = useQueryClient();
  return useMutation<CommentDTO, Error, UpdateCommentVisibilityVariables>({
    mutationFn: ({ taskId, commentId, isInternalOnly }) =>
      updateCommentVisibility(taskId, commentId, isInternalOnly),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['comments', vars.taskId] });
    },
  });
}
